const getters = {
    token: (state) => state.user.token,
    roles: (state) => state.user.roles,
    userInfo: (state) => state.user.userInfo,
    curActiveChatId: (state) => state.user.curActiveChatId,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js